import { render, staticRenderFns } from "./ImageUploader.vue?vue&type=template&id=49567821&scoped=true&lang=pug&"
import script from "./ImageUploader.vue?vue&type=script&lang=coffee&"
export * from "./ImageUploader.vue?vue&type=script&lang=coffee&"
import style0 from "./ImageUploader.vue?vue&type=style&index=0&id=49567821&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49567821",
  null
  
)

component.options.__file = "ImageUploader.vue"
export default component.exports